import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle, faCirclePlus,
} from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { UseFormPayload } from '@domain-group/react-hooks'

import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useProvider from '@hooks/useProvider'

interface ProviderTileProps {
  formPayload: UseFormPayload,
  isSelected?: boolean,
  providerId: number,
}

const ProviderTile = (props: ProviderTileProps) => {
  const {
    formPayload, isSelected, providerId,
  } = props

  const { provider, provider: { id, title } } = useProvider({ id: providerId })

  const logoUrl = digObject(provider, 'alternate_logo.thumb', null)
  const isPreferred = digObject(provider, 'options.preferred_supplier', false)

  const { setEntityState } = formPayload

  return (
    <ListItem
      boxProps={{
        border: '1px solid',
        borderRadius: 5,
        paddingLeft: 0,
        marginBottom: 'medium',
      }}
      disableHover={isSelected}
      forceBottomBorder
      onClick={isSelected ? undefined : () => setEntityState({ selectedProviderId: id })}
    >
      <Image
        backgroundSize="contain"
        boxProps={{
          borderRight: '1px solid',
          borderColor: 'lineColor',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
        }}
        height={62}
        url={logoUrl}
        width={80}
      />

      <Box padding="large">
        <Box flexDirection="column" justifyContent="center">
          <Text fontSize="small">{title}</Text>

          {isPreferred && (
            <Text color="lightGrey" fontSize="xsmall" marginTop="small">
              Preferred Supplier
            </Text>
          )}
        </Box>

        <Box
          fontSize="medium"
          color={isSelected ? 'green' : 'mysteryGrey'}
          width="fit-content"
          variant="center"
        >
          <FontAwesomeIcon icon={isSelected ? faCheckCircle : faCirclePlus} />
        </Box>
      </Box>
    </ListItem>
  )
}

export default ProviderTile
